import React, { useCallback, useLayoutEffect } from "react"
import { Image } from "~/ui/primitives"
import { observer } from "mobx-react-lite"
import FastImage from "~/ui/FastImage"
import { useSafeAreaInsets } from "~/ui/safe-area"
import useNavigation from "~hooks/useNavigation"
import { Heading4 } from "~components/heading"
import { ButtonOutline } from "~components/button"
import styled from '~/ui/styled'

const pic = require("../../../assets/images/accusation-success.png")

const Container = styled.View<{ paddingBottom: number }>`
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 30px;
  text-align: center;
  padding-bottom: ${({ paddingBottom }) => `${paddingBottom + 50}px`};
`

const ContentText = styled(Heading4)`
  text-align: center;
  color: ${({ theme }) => theme.colors.secondaryText};
`

const GapBottom = styled.View<{ gap: number }>`
  margin-bottom: ${({ gap }) => `${gap}px`};
`

const AccusationSuccess: React.FC = () => {
  const insets = useSafeAreaInsets()
  const navigation = useNavigation()
  const back = useCallback(() => {
    navigation.pop(2)
  }, [])
  useLayoutEffect(() => {
    navigation.setOptions({
      headerBackVisible: false,
    })
  }, [])
  return (
    <Container paddingBottom={insets.top}>
      <Image src={pic} resizeMode={FastImage.resizeMode.cover} />
      <GapBottom gap={15} />
      <Heading4 text="举报成功" />
      <GapBottom gap={15} />
      <ContentText text="感谢您的反馈，工作人员查证后将对该账号进行相应处理!" />
      <GapBottom gap={30} />
      <ButtonOutline text="返回" onClick={back} />
    </Container>
  )
}

export default observer(AccusationSuccess)
